export type PagesSpotlightMaybeInternalProps = {
	tabData: { url: string | null | undefined };
	projectId: string | null | undefined;
};

export const USER_PROPERTY_KEY = 'horizontal-nav-tabs-pages-spotlight-space-connected-seen';
